<script lang="ts" setup>
  import { ref } from 'vue'

  import { QuestionMarkCircleIcon } from '@heroicons/vue/24/solid'
  import type { ResolvedActivity } from '@/stores'

  const props = defineProps<{
    activityItem: ResolvedActivity
  }>()

  const resolvedActivity = ref(props.activityItem)
  const { activity } = resolvedActivity.value
</script>

<template>
  <div class="relative flex items-start space-x-3">
    <div>
      <div class="relative px-1">
        <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
          <QuestionMarkCircleIcon
            aria-hidden="true"
            class="h-5 w-5 text-gray-400" />
        </div>
      </div>
    </div>

    <div class="min-w-0 flex-1">
      <div>
        <div class="text-sm">
          {{ activity.originId }}
          <!--                        <a :href="activityItem.person.href" class="font-medium text-gray-900">{{-->
          <!--                          activityItem.person.name-->
          <!--                        }}</a>-->
        </div>
        <p class="mt-0.5 text-sm text-gray-500">
          {{ $formatter.DateTime(activity.createdAt!) }}
        </p>
      </div>
      <div class="mt-2 text-sm text-gray-700">unsupported activity type: {{ activity.type }}</div>
    </div>
  </div>
</template>
